import { Avatar, Box, Button, Grid, Menu, Typography } from '@mui/material';
import { Account } from '@vectopus/atlas-icons-react';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import { AppContext } from '@/utils/appContext';
import { useIsAuthenticated } from '@azure/msal-react';

const ProfileNav = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const appContext = useContext(AppContext);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const isAuthenticated = useIsAuthenticated();

  return (
    <>
      {
        isAuthenticated ? (
          <>
            <Grid item>
              <Button
                sx={{ minWidth: 'auto' }}
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <Avatar
                  alt={``}
                  src={''}
                />
              </Button>
            </Grid>
            <Menu
              className={classes.profileNav}
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button'
              }}
              transformOrigin={{ horizontal: 'center', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
            >

              {/*<Box pt={2} pb={2} pr={4} pl={4} sx={{ borderBottom: '1px solid #00000029' }}>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'h5'} component={'h5'}>
                                    {t('my_holidays')}
                                </Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'h5'} component={'h5'}>
                                    {t('Huniverse_card')}
                                </Typography>
                            </Link>
                        </Box>

                        <Box pr={4} pl={4} pt={2} pb={2} sx={{ borderBottom: '1px solid #00000029' }}>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('myHu_lottery')}</Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Favourites')}</Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Calendar')}</Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Saltafila_order')}</Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Holiday_friends')}</Typography>
                            </Link>
                        </Box>*/}

              <Box pr={4} pl={4} pt={2} pb={2}>
                {/*<Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Visit_profile')}</Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Personal_info')}</Typography>
                            </Link>
                            <Link to={'/'} onClick={handleClose} className={classes.disabledLink}>
                                <Typography variant={'body2'} component={'p'}>{t('Privacy_consent_profile')}</Typography>
                            </Link>*/}
                <Typography variant={'body2'} component={'p'} onClick={() => appContext.handleLogout()}
                            sx={{ cursor: 'pointer' }}>{t('Logout')}</Typography>
              </Box>
            </Menu>
          </>
        ) : (
          <Grid item onClick={() => appContext.handleLogin()}>
            <Account size={22} />
          </Grid>
        )
      }
    </>
  )
    ;
};

export default ProfileNav;

const useStyles = makeStyles()((theme) => {
  return {
    profileNav: {
      '.MuiPaper-root': {
        boxShadow: '0px 2px 12px #00000029',
        border: 'none',
        marginTop: 20,
        'a': {
          textDecoration: 'none',
          color: '#000'
        }
      }
    },
    disabledLink: {
      pointerEvents: 'none',
      color: '#e6e6e6!important'
    }
  };
});
